module.exports = __webpack_public_path__ + "static/creativity-2b8bdfc2865454966cd944cb76ff7e57.png";